export enum ActionPermissionType {
  Delivery = 'Delivery',
}

export enum ActionPermissionStatus {
  Waiting = 'Waiting',
  Approve = 'Approve',
  Used = 'Used',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
}

export interface IActionPermission {
  id: number;
  siteId: number | null;
  cellId: number | null;
  cityId: number | null;
  inquiringCustomerId: string;
  inquiringCustomerPhoneNumber: string;
  inquiringCustomerName: string;
  shippingCompanyId: number | null;
  authorizerCustomerId: string;
  authorizerCustomerPhoneNumber: string;
  authorizerCustomerName: string;
  permissionType: ActionPermissionType;
  status: ActionPermissionStatus;
  startDate: string | null;
  expiryDate: string | null;
  usesCounter: number;
  usesLimit: number | null;
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
  statusChangedByUserId: string | null;
  statusChangedByName: string | null;
}
